import type { AppState } from '../rootReducer';

export const getAppError = (state: AppState) => state.app.appError;
